// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import API, { STUDENTS_API } from "../../routes/api.path";
import { ApiMananger } from "./apiMananger";

const eleveApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getEleve: build.query({
      query: (id) => `eleves/${id}/`,
      // `providesTags` (et non `invalidatesTags` : une query ne peut pas
      // invalider). Sans ça, la modification d'un profil ne rafraîchissait
      // jamais cette query, et le nom / la classe restaient périmés au retour.
      providesTags: ["Eleves"],
      keepUnusedDataFor: 1000 * 60 * 60 * 24,
    }),
    getEleves: build.query({
      query: (id) => `${STUDENTS_API}/${id.coachId}/${id.schoolId}/`,
      providesTags: ["Eleves", "Appels"],
      keepUnusedDataFor: 1000 * 60 * 60 * 24,
    }),
    getElevesBySchoolByClasse: build.query({
      query: ({ schoolId, classeId }) =>
        `students/?classeId=${classeId}&schoolId=${schoolId}`,
      providesTags: ["Eleves", "Appels"],
      keepUnusedDataFor: 1000 * 60 * 60 * 24,
    }),
    getElevesByParent: build.query({
      query: ({ parentId }) => `eleves/?parrentId=${parentId}`,
      // query: (id) => API.ELEVES_PARENT.GET(id),
      providesTags: ["Eleves", "Appels"],
       keepUnusedDataFor: 1000 * 60 * 60 * 24,
    }),
    addEleves: build.mutation({
      query({ body, token }) {
        return {
          url: API.ELEVES_API.ADD(),
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body,
        };
      },
      invalidatesTags: ["Eleves"],
    }),
    updateEleve: build.mutation({
      query(data) {
        const { id, ...body } = data;
        return {
          url: `eleves/${id}/`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Eleves"],
    }),
    deleteEleve: build.mutation({
      query(id) {
        return {
          url: `eleves/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Eleves"],
    }),
  }),
});

export const {
  useGetEleveQuery,
  useAddElevesMutation,
  useGetElevesQuery,
  useGetElevesBySchoolByClasseQuery,
  useGetElevesByParentQuery,
  useUpdateEleveMutation,
  useDeleteEleveMutation,
} = eleveApi;
